import { Box, IconButton, InputAdornment, Link } from '@mui/material';
import { TextField } from 'src/components/new/inputs/TextField';
import { Link as RouterLink } from 'react-router-dom';
import { Button } from 'src/components/new/Button';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'src/store/store';
import { Visibility, VisibilityOff } from '@mui/icons-material';

interface ChangeEmailProps {
  onEmailChange: (data: { password: string; newEmail: string }) => void;
}

interface NewEmailInfo { 
  password: string;
  newEmail: string;
}

interface NewEmailInfoErrors { 
  passwordError: string;
  newEmailError: string;
}

const ChangeEmail: React.FC<ChangeEmailProps> = ({ onEmailChange }) => {
  const isChangeEmailLoading = useSelector((state: RootState) => state.user.isChangeEmailLoading);

  const [showPassword, setShowPassword] = useState(false);
  const [newEmailInfo, setNewEmailInfo] = useState<NewEmailInfo>({
    password: '',
    newEmail: '',
  });

  const [newEmailErrors, setNewEmailErrors] = useState<NewEmailInfoErrors>({
    passwordError: '',
    newEmailError: '',
  });

  const handlePasswordClick = () => {
    setShowPassword((prev) => !prev);
  };

  const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
  };

  const handleEmailChange = () => {
    const newErrors: any = {};
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (newEmailInfo.password === '') {
      newErrors.passwordError = 'Password cannot be empty';
    }

    if (newEmailInfo.newEmail === '') {
      newErrors.newEmailError = 'Email cannot be empty';
    }

    if (newEmailInfo.newEmail !== '' && !emailRegex.test(newEmailInfo.newEmail)) {
      newErrors.newEmailError = 'Provided value must be a valid email';
    }

    setNewEmailErrors(newErrors);

    const hasErrors = Object.values(newErrors).some((error) => error !== '');
    if (!hasErrors) {
      onEmailChange(newEmailInfo);
    }
  };

  return (
    <Box sx={{ p: 4, backgroundColor: '#f7f9ff', mb: 2 }}>
      <TextField
        label="Current Password"
        value={newEmailInfo.password}
        name="password"
        id="password"
        required={true}
        type={showPassword ? 'text' : 'password'}
        endAdornment={
          <InputAdornment position="end" sx={{mr: 2}}>
            <IconButton
              aria-label="toggle password visibility"
              onClick={handlePasswordClick}
              onMouseDown={handleMouseDownPassword}
              edge="end"
            >
              {showPassword ? <VisibilityOff /> : <Visibility />}
            </IconButton>
          </InputAdornment>
        }
        onChange={(e) => setNewEmailInfo((prev: any) => ({ ...prev, password: e.target.value }))}
        error={newEmailErrors.passwordError}
      />
      <TextField
        label="New Email"
        value={newEmailInfo.newEmail}
        name="newEmail"
        required={true}
        id="newEmail"
        onChange={(e) => setNewEmailInfo((prev: any) => ({ ...prev, newEmail: e.target.value }))}
        error={newEmailErrors.newEmailError}
      />
      <Button type="primary" disabled={isChangeEmailLoading} onClick={handleEmailChange}>
        {isChangeEmailLoading ? 'Please wait...' : 'Send Verification Link'}
      </Button>
    </Box>
  );
};

export default ChangeEmail;
